(ns renolit-roofing-service.data-loading
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::loading
 (fn [db [_ id]]
   (get-in db [:loading id])))

(rf/reg-event-db
 ::set-loading
 (fn [db [_ id message]]
   (assoc-in db [:loading id] {:message message})))

(rf/reg-event-db
 ::stop-loading
 (fn [db [_ id]]
   (update db :loading dissoc id)))
